import { escapeText } from '../utils'
import { Join, PathsToStringProps } from '@sales-center/common'

export type SearchableFieldSet<T> = {
  /*eslint-disable */
  // @ts-ignore
  readonly propertyNames: Join<PathsToStringProps<T>, '/'>[]
  readonly matchType: 'eq' | 'contains'
  readonly include?: RegExp | ((value: string) => boolean)
  readonly formatter?: (value: string) => string
}

export interface ISearch<T> {
  placeholder: string
  value: string
  searchFields: SearchableFieldSet<T>[]
}

export const normalizeSearch = <T>({
  value,
  searchFields,
}: ISearch<T>): string => {
  if (value === '') return ''
  const searchText = value?.trim()
  const escaped = escapeText(searchText)

  const options = searchFields
    .filter(({ include }) => {
      if (!!include) {
        if (typeof include === 'function') return include(searchText)
        else return include.test(searchText)
      }
      return true
    })
    .map(({ matchType, propertyNames, formatter }) => {
      const formatted = formatter ? escapeText(formatter(searchText)) : escaped

      switch (matchType) {
        case 'eq':
          return propertyNames.map((name) => `(${name} eq ${formatted})`)
        case 'contains':
          return propertyNames.map(
            (name) => `(contains(toLower(${name}), ${formatted}))`,
          )
      }
    })
    .reduce((prev, cur): string[] => [...prev, ...cur])

  return `(${options.join(' or ')})`
}
